<template>
  <aside id="ShopCartDrawer">
    <div class="shop_cart_container" data-section-menu-box>
      <div class="title_box" data-section-title-box>
        <div>
          <p>ShopCart</p>
          <h4>購物車</h4>
        </div>
        <button @click="$emit('close-action')">
          <span class="material-symbols-rounded"> close </span>
        </button>
      </div>

      <ol class="product_list custom_scrollbar" data-lenis-prevent>
        <li
          v-for="(item, itemIndex) in shopCartData"
          :key="`shopCartItem${itemIndex}`"
          data-section-product-card
        >
          <ProductCard :shopCartData="item" />
        </li>
      </ol>

      <div class="button_box">
        <div data-section-button-box>
          <router-link
            class="main_button dark"
            @click.native="$emit('close-action')"
            to="/checkout"
            >前往結帳
            <span class="icon material-symbols-rounded"> east </span>
          </router-link>
        </div>
      </div>
    </div>

    <div
      @click="$emit('close-action')"
      class="background_box"
      data-section-bg-box
    ></div>
  </aside>
</template>

<script>
import { ShopCartProductTool } from "@/tools/shopCartProductTool.js";
import { shopCartDrawer } from "@/animations/shopCartDrawer";
import ProductCard from "@/components/shopCartDrawer/ProductCard.vue";
export default {
  name: "ShopCartDrawer",
  components: {
    ProductCard,
  },
  props: {
    shopCartDrawerStatus: Boolean,
  },
  data() {
    return {
      animation: null,
    };
  },
  methods: {
    InitAnimation() {
      this.animation = new shopCartDrawer(
        document.getElementById("ShopCartDrawer")
      );
      this.animation.Reset();
    },
    Open() {
      this.animation.Open();
    },
    Close() {
      this.animation.Close();
    },
  },
  computed: {
    shopCartData() {
      return new ShopCartProductTool().shopCart;
    },
  },
  watch: {
    shopCartDrawerStatus() {
      if (this.shopCartDrawerStatus) {
        this.Open();
        document.querySelector("body").style.overflowY = "hidden";
      } else {
        this.Close();
        document.querySelector("body").style.overflowY = "auto";
      }
    },
  },
  mounted() {
    this.InitAnimation();
  },
};
</script>
